<script>
    export default function(props = {}) {
        const root = this;

        return {
            maxLength: props.maxLength ?? null,
            async mounted(element, data = this) {
                if (!element.closest('.form-group'))
                    throw 'The counter component must be placed inside a .form-group element.';

                // Set the initial values.
                element.closest('.form-group').querySelector('.character-count').innerText = element.value.length;
                element.closest('.form-group').querySelector('.word-count').innerText = getWordCount(element.value);

                // Add the input event handler.
                element.addEventListener('input', this.input);

                // This makes sure this component is reset when the reset event is triggered against any parent element (not just a form). See https://jsfiddle.net/ojq0crft/ for why we specify true at the end.
                document.addEventListener('reset', this.reset, true);

                // Call the root mounted method.
                root.mounted(element, data);
            },
            unmounted(element, data = this) {
                // Remove the input event handler.
                element.removeEventListener('input', this.input);

                // Remove the reset event handler.
                document.removeEventListener('reset', this.reset, true);

                // Call the root unmounted method.
                root.unmounted(element, data);
            },
            input(e) {
                // Work out the length.
                const length = e.target.value.length;

                // Update the character count.
                if (this.maxLength == null || length <= this.maxLength)
                    e.target.closest('.form-group').querySelector('.character-count').innerText = length;
                else {
                    alert('You have exceeded the maximum permitted characters.');

                    // Cut off the extra text.
                    e.target.value = e.target.value.substring(0, options.maxLength);
                }

                // Update the word count.
                e.target.closest('.form-group').querySelector('.word-count').innerText = getWordCount(e.target.value);
            },
            reset(e) {
                // Make sure the target contains the element.
                if (e.target.contains(this.$refs.root))
                    this.$refs.root.closest('.form-group').querySelector('.character-count').innerText = this.$refs.root.closest('.form-group').querySelector('.word-count').innerText = '0';
            }
        };
    };

    function getWordCount(text) {
        return text.replaceAll('\n', ' ').split(' ').filter(w => w.length > 0).length;
    }
</script>